export default {
  tabs: {
    gift_cards: 'Gift cards',
    settings: 'Settings',
  },
  gift_cards: {
    title: 'Gift cards',
    subtitle: 'Manage all gift cards for your restaurant',
    buttons: {
      create: 'Create gift card',
      redeem: 'Redeem gift card',
      check_balance: 'Check balance',
    },
    search: {
      placeholder: 'Input search text',
    },
    columns: {
      code: 'Code',
      status: 'Status',
      balance: 'Balance',
      value: 'Value',
      email: 'Purchaser',
      source: 'Source',
      created_at: 'Created',
    },
    statuses: {
      active: 'Active',
      partially_redeemed: 'Partially Redeemed',
      redeemed: 'Redeemed',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Gift Card Settings',
      subtitle: 'Configure gift card options for your restaurant',
      availability: {
        title: 'Enable Gift Cards',
        subtitle: 'Allow customers to purchase and redeem gift cards',
        buttons: {
          enable: 'Enable',
          disable: 'Disable',
        },
      },
    },
    redemption_options: {
      title: 'Redemption Options',
      subtitle: 'Choose where customers can redeem gift cards',
      redemption_mode: {
        title: 'Redemption Mode',
        subtitle: 'This affects the copy shown on your gift card landing page',
        buttons: {
          online: 'Online only',
          online_and_store: 'Online & In-Store',
        },
      },
    },
  },
  summary: {
    total_value: 'Total Value',
    total_active: 'Total Active',
    redeemed_this_month: 'Redeemed This Month',
  },
};
